const GOOGLE_PROVIDER_ID = 'google.com';

const isNonEmptyString = (value) =>
  typeof value === 'string' && value.trim() !== '';

const firstNonEmptyString = (...values) => {
  for (const value of values) {
    if (isNonEmptyString(value)) {
      return value.trim();
    }
  }
  return '';
};

const hasGoogleProvider = (providerData) =>
  Array.isArray(providerData) &&
  providerData.some((provider) => provider?.providerId === GOOGLE_PROVIDER_ID);

export const getNameFromEmail = (email) => {
  if (!isNonEmptyString(email)) {
    return '';
  }
  const [localPart = ''] = email.split('@');
  return localPart.trim();
};

export const buildFullName = (firstName, lastName) =>
  [firstName, lastName]
    .map((part) => (isNonEmptyString(part) ? part.trim() : ''))
    .filter(Boolean)
    .join(' ');

const normalizeComparableName = (value) =>
  isNonEmptyString(value) ? value.trim().toLowerCase().replace(/\s+/g, '') : '';

export const isNameDerivedFromEmail = (name, email) => {
  const normalizedName = normalizeComparableName(name);
  const normalizedEmailName = normalizeComparableName(getNameFromEmail(email));
  return Boolean(normalizedName && normalizedEmailName && normalizedName === normalizedEmailName);
};

export const resolveUserDisplayName = (user = {}) => {
  const fullName = firstNonEmptyString(user.fullName);
  const manualSignupName = buildFullName(user.firstName, user.lastName);
  const username = firstNonEmptyString(user.username);
  const authDisplayName = firstNonEmptyString(user.authDisplayName);
  const persistedDisplayName = firstNonEmptyString(user.displayName);
  const emailName = getNameFromEmail(user.email);
  const signupMethod = firstNonEmptyString(user.signupMethod).toLowerCase();

  const isManualSignup = signupMethod === 'manual' || Boolean(manualSignupName);
  const isGoogleSignup =
    signupMethod === 'google' || (hasGoogleProvider(user.providerData) && !isManualSignup);

  if (isManualSignup) {
    return firstNonEmptyString(
      fullName,
      manualSignupName,
      username,
      persistedDisplayName,
      authDisplayName,
      emailName,
      'User',
    );
  }

  if (isGoogleSignup) {
    const fullNameForGoogle = isNameDerivedFromEmail(fullName, user.email) ? '' : fullName;
    const usernameForGoogle = isNameDerivedFromEmail(username, user.email) ? '' : username;
    const authDisplayNameForGoogle = isNameDerivedFromEmail(authDisplayName, user.email)
      ? ''
      : authDisplayName;
    const persistedDisplayNameForGoogle = isNameDerivedFromEmail(persistedDisplayName, user.email)
      ? ''
      : persistedDisplayName;
    return firstNonEmptyString(
      fullNameForGoogle,
      authDisplayNameForGoogle,
      usernameForGoogle,
      persistedDisplayNameForGoogle,
      emailName,
      'User',
    );
  }

  return firstNonEmptyString(
    fullName,
    manualSignupName,
    username,
    persistedDisplayName,
    authDisplayName,
    emailName,
    'User',
  );
};
